/** Rahmen des Wizards: Titel, Stepper, Fußleiste, Fehler. */
const wizShellDE = {
  wizBackToCampaigns: 'Kampagnen',
  wizLegacySetup: 'Erweiterte Einrichtung',
  wizOpenWizard: 'Zum geführten Assistenten',
  wizTitle: 'Neue Kampagne',
  wizStepJob: 'Stelle',
  wizStepCandidates: 'Kandidaten',
  wizStepJudging: 'KI-Bewertung',
  wizStepList: 'Kandidatenliste',
  wizStepApproach: 'Ansprache',
  wizStepMessages: 'Nachrichten',
  wizStepReview: 'Prüfen & starten',
  wizCancel: 'Abbrechen',
  wizBack: 'Zurück',
  wizNext: 'Weiter',
  wizStart: 'Kampagne starten',
  wizSaveDraft: 'Als Entwurf speichern',
  wizEditTitle: 'Kampagne bearbeiten',
  wizSaveChanges: 'Änderungen speichern',
  wizStartedNotice:
    'Diese Kampagne läuft bereits. Briefing, Blacklists, Bewertung und Einstellungen kannst du hier ändern. Suche und Nachrichten-Ablauf stehen fest und werden nur angezeigt – den Ablauf änderst du im Flow-Editor.',
  wizLoading: 'Wird geladen …',
  wizSaving: 'Wird gespeichert …',
  wizSaved: 'Gespeichert',
  wizLoadError: 'Der Entwurf konnte nicht geladen werden.',
  wizSaveError: 'Der Entwurf konnte nicht gespeichert werden.',
  wizNameTaken: 'Eine Kampagne mit diesem Namen gibt es schon.',
  wizNoAccount: 'Verbinde zuerst ein LinkedIn-Konto.',
  wizNewBadge: 'NEU',
  wizBreadcrumbNew: 'Neue Kampagne',
  wizNotDraft: 'Diese Kampagne wurde bereits gestartet und kann hier nicht mehr bearbeitet werden.',
  wizStartFailed: 'Die Kampagne konnte nicht gestartet werden.',
  wizMissingBriefing: 'Beschreibe zuerst die Stelle.',
  wizMissingName: 'Gib der Kampagne einen Namen.',
  wizMissingAccount: 'Wähle einen LinkedIn-Account als Absender.',
  wizMissingLocations: 'Füge mindestens einen Ort hinzu.',
  wizMissingSearchUrl: 'Füge den Link einer LinkedIn-Suche ein.',
  wizMissingClasses: 'Wähle mindestens eine Klasse (A oder B) aus, die angesprochen werden soll.',
  wizMissingCalendarUrl: 'Füge den Link zu deinem Kalender ein.',
  wizMissingBonus: 'Nenne die Höhe der Prämie.',
  wizMissingInmailCredit: 'Beantworte die Frage, ob das LinkedIn-Konto InMail-Guthaben hat.',
  wizMissingWorkWindow:
    'Am LinkedIn-Konto sind noch keine Arbeitstage und -zeiten festgelegt. Ohne sie lässt sich die Kampagne nicht starten.',
  wizStartWorkWindowLink: 'Zu den Kontoeinstellungen',
  wizMissingApproveChoice: 'Wähle, ob jede Nachricht vorher freigegeben oder automatisch gesendet wird.',
  wizMissingRecontactChoice: 'Wähle, wie mit bereits kontaktierten Kandidaten umgegangen wird.',
  wizRunningTitle: 'Diese Kampagne wurde bereits gestartet und kann nicht mehr geändert werden.',
  wizRunningText:
    'Wenn du etwas ändern möchtest, stoppe die Kampagne und lege eine neue Kampagne mit den neuen Kriterien an.',
  wizDuplicate: 'Als neue Kampagne duplizieren',
  wizDuplicateSuffix: 'Kopie',
  wizDuplicateError: 'Die Kampagne konnte nicht dupliziert werden.',
  wizSearchRestartTitle: 'Neue Kandidatensuche starten?',
  wizSearchRestartText:
    'Du änderst Suchkriterien einer Kampagne, für die SAIA schon gesucht hat. Dadurch startet eine neue Kandidatensuche: Die bisherigen Kandidaten und ihre Bewertungen werden verworfen, und der Nachrichten-Ablauf wird neu berechnet.',
  wizSearchRestartConfirm: 'Neue Suche starten',
  wizSearchRestartCancel: 'Abbrechen',
  wizSearchedHint: 'Änderungen an den Suchkriterien starten eine neue Kandidatensuche.',
};
export default wizShellDE;
